import * as React from 'react';
import { useGlobalState } from 'piral-core';
export function withPiletState(Component, id, actions) {
    const StateView = (props) => {
        const state = useGlobalState((s) => s.containers[id]);
        return React.createElement(Component, { state: state, actions: actions, ...props });
    };
    StateView.displayName = `StateView_${id}`;
    return StateView;
}
//# sourceMappingURL=withPiletState.js.map